import type { PageFunction } from '@unifyapps/defs/types/pageFunction';
import { produce } from 'immer';
import omit from 'lodash/omit';
import { DEPENDENCY_KEYS_TO_OMIT_DURING_SERIALIZATION } from '../no-code/dependency/const';
import type { BuildDependencyGraphItem } from '../dependency/utils/buildDependencyGraph';
import type { DynamicAndConditionalPathHandler } from '../no-code/context/DependencyGraphContext/handlers';
import { DependencyHelper } from '../dependency/helpers/DependencyHelper';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class -- false positive
export class PageFunctionHelper {
  static getDependsOn(pageFunction: PageFunction) {
    return pageFunction.dpOn;
  }

  static updateDependency(
    pageFunction: PageFunction,
    dependencyItem?: BuildDependencyGraphItem<DynamicAndConditionalPathHandler>,
  ) {
    return produce(pageFunction, (draft) => {
      draft.dpOn = DependencyHelper.getDependsOn(dependencyItem);
    });
  }

  static getAdaptedPageFunctionForDependencyGraph(pageFunction: PageFunction) {
    return omit(pageFunction, DEPENDENCY_KEYS_TO_OMIT_DURING_SERIALIZATION);
  }
}
